module.exports = __webpack_public_path__ + "static/media/sketch-01.8ec89796.png";